import { get } from "../config/api";

export interface NoticeAction {
  label: string;
  url: string;
}

export interface NoticeContent {
  title: string;
  text: string;
  confirmation_button: string;
  action: NoticeAction | null;
}

export interface Notice extends NoticeContent {
  id: number;
  version: number;
  starts_at: string;
  ends_at: string;
}

export default class NoticeService {
  public static async current() {
    return get<Notice | null>("/notices/current");
  }
}
